import request from '@/utils/request'

export function getIndex(params) {
  return request({
    url: '/api/store/applicationIndex',
    method: 'get',
    params
  })
}

export function getList(params) {
  return request({
    url: '/api/store/application_category',
    method: 'get',
    params
  })
}

export function getMore(params) {
  return request({
    url: '/api/store/application/more',
    method: 'get',
    params
  })
}

export function getDetail(id) {
  return request({
    url: '/api/store/application/' + id,
    method: 'get',
  })
}

export function getComment(id) {
  return request({
    url: '/api/comment/' + id,
    method: 'get',
  })
}

export function search(params) {
  return request({
    url: '/api/store/application/search',
    method: 'get',
    params
  })
}

export function comment(data){
  return request({
    url: '/api/comment',
    method: 'post',
    data
  })
}

export function getCategory(code){
  return request({
    url: '/api/platform/categoryTree/'+ code,
    method: 'get',
  })
}

export function getTransferTraining(data){
  return request({
    url: '/api/train/transfer_page',
    method: 'post',
    data
  })
}